import { Snowflake } from "lucide-react";

export function Logo({ size = "md", withText = true }) {
  const dims = size === "lg" ? "h-10 w-10" : size === "sm" ? "h-7 w-7" : "h-9 w-9";
  const text = size === "lg" ? "text-2xl" : "text-lg";
  return (
    <div className="flex items-center gap-2.5" data-testid="app-logo">
      <div className={`relative ${dims} rounded-xl flex items-center justify-center bg-cyan-400/10 border border-cyan-400/30 glow-cyan`}>
        <Snowflake className="h-1/2 w-1/2 text-cyan-300" />
      </div>
      {withText && (
        <span className={`font-display font-bold tracking-tight ${text} text-foreground`}>
          Sub<span className="text-cyan-300">Zero</span>
        </span>
      )}
    </div>
  );
}
